export const CODE_MESSAGE: Record<number, string> = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '请求参数异常，类型不正确。',
  401: '登陆失效',
  403: '用户没有权限。',
  404: '访问地址不存在',
  406: '请勿重复请求。',
  409: '非法访问',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。',
};

type ContentType = 'json' | 'form-data' | 'form-urlencoded' | string;
export const C_M = new Map<ContentType, string>([
  ['json', 'application/json'], // json格式提交
  ['form-data', 'multipart/form-data'], // 文件上传
  ['form-urlencoded', 'application/x-www-form-urlencoded'], // 表单提交
]);

export const IS_BROWSER = (typeof window !== 'undefined');

const kb = 1024;
const mb = 1024 * kb;
const gb = 1024 * mb;
const tb = 1024 * gb;

export const SIZE_UNIT = { kb, mb, gb, tb };

const group_map: Record<string, number> = {
  test: 2,
  prod: 2,
  ultra: 4,
};
export const GROUP_ID = group_map[process.env.NEXT_PUBLIC_N_ENV] ?? 2;

export const h5_path = process.env.NEXT_PUBLIC_H5_HOST;

export const KANAL_COOKIE_KEY = "fwkanal"
